import { render, staticRenderFns } from "./SaveGiftingReminder.vue?vue&type=template&id=664f2506&scoped=true&"
import script from "./SaveGiftingReminder.vue?vue&type=script&lang=js&"
export * from "./SaveGiftingReminder.vue?vue&type=script&lang=js&"
import style0 from "./SaveGiftingReminder.vue?vue&type=style&index=0&id=664f2506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f2506",
  null
  
)

export default component.exports